import React, { PureComponent } from 'react';
import BuscadorCuentasContables from '../../Common/BuscadorCuentasContables'

class RegistroRenglonAsiento extends PureComponent {
    constructor(props) {
        super(props);this.state = {
            debeActivo: true,
            haberActivo: true,
            inputBuscadorCuentaContable:"",
        };
        this.handleImporteChange = this.handleImporteChange.bind(this);
        this.handleMonedaChange = this.handleMonedaChange.bind(this);
    }

    componentDidMount(){
        $('[data-toggle="tooltip"]').tooltip();
    }

    componentDidUpdate() {
        $('[data-toggle="tooltip"]').tooltip();
    }

    handleImporteChange(event) {
        const { value, name } = event.target;
        const { registro, actualizarImporteRenglon, monedasAsiento } = this.props;

        let tipoOperacion = name === 'inputImporteDebe' ? 1 : 2;
        let codigoMoneda = registro && registro.MonedaSalidaCodigo || registro && registro.ModeloMonedaSalidaCodigo;
        let monedaSeleccionada = monedasAsiento.find(moneda => moneda.Codigo == codigoMoneda)

        const cleanedValue = value.replace(/[^\d,]|e/gi, '');
        const parts = cleanedValue.split(',');
        if (parts.length > 2 || (parts.length === 2 && parts[1].length > 2)) {
            return; 
        }

        if (parts[0].length > 9) {
            return;
        }

        if (parts[0].length > 1 && parts[0][0] === '0') {
            return '';
        }

        if (parts[0] === '0' && parts.length === 1) {
            return '';
          }

        if (parts.length === 2 && parts[0] === '') {
            return '';
        }

        actualizarImporteRenglon(registro.renglonId, cleanedValue, monedaSeleccionada? monedaSeleccionada.Codigo : "PESO", monedaSeleccionada ? monedaSeleccionada.Id : 1, tipoOperacion); 

        if (name === 'inputImporteDebe') {
            this.setState({ debeActivo: true, haberActivo: false});
        } else if (name === 'inputImporteHaber') {
            this.setState({ debeActivo: false, haberActivo: true});
        }

        if (cleanedValue === '') {
            this.setState({ debeActivo: true, haberActivo: true });
        }
    }

    handleMonedaChange = (event) => {
        const {registro, cuentasContables, onCuentaContableChange, onValorReferenciaChange, onImporteChange, OnMonedaSeleccionadaChange, monedasAsiento}  = this.props;

        let monedaSeleccionada = monedasAsiento.find(moneda => moneda.Id == event.target.value)

        let tipoOperacion = this.state.debeActivo ? 1 : 2;

        let cuentaContableValida = cuentasContables.find( cuenta => (cuenta.Codigo + " - " + cuenta.Descripcion) === registro.CuentaContableDescripcion && (cuenta.MonedaId === 0 || cuenta.MonedaId == nuevaMoneda));
    
        if (!cuentaContableValida) {
            onCuentaContableChange(registro.renglonId, "", "");
            onValorReferenciaChange(registro.renglonId, "")
            onImporteChange(registro.renglonId, "", monedaSeleccionada.Id, tipoOperacion);
            this.buscarCuentasContables("");
            this.setState({ inputBuscadorCuentaContable: "" });
        }

        onImporteChange(registro.renglonId, "", monedaSeleccionada.Id, tipoOperacion);

        OnMonedaSeleccionadaChange(registro.renglonId, monedaSeleccionada.Codigo, monedaSeleccionada.Id)

        this.setState({
            debeActivo: true,
            haberActivo: true
         });
    }

    handleInputReferenciaChange = (event) => {
        const {registro, OnInputValorReferencia} = this.props;
        OnInputValorReferencia(registro.renglonId, event.target.value)
    };

    handleTipoReferenciaChange = (event) => {
        const {registro, onValorReferenciaChange, cuentasContables, OnInputValorReferencia} = this.props;
        let cuentaContableSeleccionada = cuentasContables && cuentasContables.find(cuenta => cuenta.Codigo == registro.CuentaContableCodigo)

        onValorReferenciaChange(registro.renglonId, event.target.value)
        OnInputValorReferencia(registro.renglonId, "")

        if(event.target.value == 2 && (cuentaContableSeleccionada && cuentaContableSeleccionada.ValorReferencia)){
            OnInputValorReferencia(registro.renglonId, cuentaContableSeleccionada.ValorReferencia) 
        }

    };

    handleCentroCostoChange = (event) => {
        const {registro, onCentroDeCostoChange} = this.props;
        onCentroDeCostoChange(registro.renglonId, event.target.value)
    };

    handleGuardarValorInput = (cuentaId, codigo, descripcionCuenta) => {
        const { registro, onCuentaContableChange } = this.props;
        onCuentaContableChange(registro.renglonId, cuentaId, codigo, descripcionCuenta );
    };

    buscarCuentasContables = (valorInput) => {
        this.props.buscarCuentasContables(this.props.registro.renglonId, "propsModalNuevoAsiento", valorInput )
    };

    handleInputBuscadorChange = (descripcionCuenta) => {
        this.setState({ inputBuscadorCuentaContable: descripcionCuenta });
    };
    

    render() {
        const { registro, totalDebe, totalHaber, centrosCosto, cuentasContables, cuentasContablesFiltradas, inputActivo, inputCuentaContable, cambiarValorInput, cambiarInputActivo, detalleRenglonDatosDesplegados, desplegarDatosDetalleRenglonNuevoAsiento, borrarRenglon, actualizarDescripcionRenglon, actualizarImporteRenglon, index, onValorReferenciaChange, monedasAsiento} = this.props;

        let totalHaberValor = !this.state.debeActivo && this.state.haberActivo
        let estiloInputRenglonCuentaContable = registro && registro.ModeloContableCabeceraId == null ? " AsientosContables__modalNuevoAsiento__registroGrillaRenglonInput" : "";
        // let estiloCuentaContableHaber = registro && registro.ModeloContableCabeceraId && registro.TipoOperacion == 2 ? " AsientosContables__modalNuevoAsiento__registroGrillaRenglon--haber" : "";
        let estiloCuentaContableHaber = registro && registro.TipoOperacion == 2 ? " AsientosContables__modalNuevoAsiento__registroGrillaRenglon--haber" : "";
        let estaDesplegado = registro && detalleRenglonDatosDesplegados && (detalleRenglonDatosDesplegados == registro.renglonId);
        let asientoContableDescripcion = registro && registro.DescripcionRenglon ? (registro.DescripcionRenglon.length > 30 ? registro.DescripcionRenglon.substring(0, 30) + '...' : registro.DescripcionRenglon) : '';
        let cuentaContableDescripcion = registro && registro.CuentaContableDescripcion ? (registro.CuentaContableDescripcion.length > 32 ? registro.CuentaContableDescripcion.substring(0, 32) + '...' : registro.CuentaContableDescripcion) : '';
        let tipoReferenciaTexto = "";
        let centrosDeCosto = [];
        let cuentasFiltradasPorMoneda = registro && registro.cuentasContablesFiltradas && registro.cuentasContablesFiltradas.filter(cuenta =>
            cuenta.MonedaId == 0 || cuenta.MonedaId == registro.ModeloMonedaSalidaId
        );
        let activaInputBuscador = !!(registro && (inputActivo === registro.renglonId));
        let estiloTotales = registro == null ? "AsientosContables__modalDetalleAsiento__registroGrillaTotales" : "";
        let estiloCursiva = registro && registro.TipoRenglon == 2 || registro && registro.RenglonAgregadoManualmente == 2 ? " letra-cursiva-grilla-renglones" : "";
        let estiloIdentacionHaber = registro && registro.TipoOperacion == 2 ? " AsientosContables__modalNuevoAsiento__registroGrillaRenglon--haber" : "";
        let estiloLetraAgregada = registro && registro.TipoOperacion == 2 ? "AsientosContables__letraAgregadaNuevoAsiento" : ""
        let letraAgregadaRenglonTipoHaber = registro && registro.TipoOperacion == 2 ? <div className={estiloLetraAgregada} >a)</div> : "" 

        if (registro) {
            switch (registro.TipoReferencia) {
                case 0:
                    tipoReferenciaTexto = "Ninguna";
                    break;
                case 1:
                    tipoReferenciaTexto = "Referencia Socio";
                    break;
                case 2:
                    tipoReferenciaTexto = "Referencia Cuenta Contable";
                    break;
                case 3:
                    tipoReferenciaTexto = "Referencia Renglón";
                    break;
                default:
                    tipoReferenciaTexto = "";
            }
        }
        centrosCosto ? centrosDeCosto = centrosCosto.map(centro => (
            <option key={centro.Id} value={centro.Id}>{centro.Descripcion}</option>
        )) : null

        let simboloMoneda = registro && registro?.MonedaSalidaCodigo ? registro?.MonedaSalidaCodigo : null
            simboloMoneda = registro && registro?.ModeloMonedaSalidaCodigo ? registro?.ModeloMonedaSalidaCodigo : simboloMoneda;
            simboloMoneda = registro && registro?.RenglonAgregadoManualmente ? null : simboloMoneda

        switch (simboloMoneda) {
            case "PESO":
                simboloMoneda = "$";
                break;

            case "DOLAR":
                simboloMoneda = "U$S";
                break;
            case "1":
                simboloMoneda = "$";
                break;
            case "2":
                simboloMoneda = "U$S";
                break;
            case 1:
                simboloMoneda = "$";
                break;
            case 2:
                simboloMoneda = "U$S";
                break;
            default:
                simboloMoneda = null;
                break;
        }
        let valorComboValorReferencia = registro && registro.TipoReferencia ? registro.TipoReferencia : "0"
        let valorComboCentroCosto = registro && registro.CentroCostoId ? registro.CentroCostoId : "0"
        let valorInputReferencia = registro && registro.ReferenciaRenglon ? registro.ReferenciaRenglon : ""

        let hayCuentaSeleccionada = cuentasContables && cuentasContables.some(cuenta => cuenta.Codigo + " - " + cuenta.Descripcion == this.state.inputBuscadorCuentaContable);
        
        let cuentaContableSeleccionada = cuentasContables && cuentasContables.find(cuenta => cuenta.Codigo == registro.CuentaContableCodigo)
        let descripcionCuentaContable = cuentaContableSeleccionada && cuentaContableSeleccionada.ValorReferencia ? `Cuenta Contable (${cuentaContableSeleccionada.ValorReferencia})` : "Cuenta Contable (Sin referencia)";

        let monedasCombo = monedasAsiento ? monedasAsiento.filter(moneda => moneda.Codigo == "PESO" || moneda.Codigo == "DOLAR") 
                                                            .map(moneda => (
                                                                <option key={moneda.Codigo} value={moneda.Id}>
                                                                {moneda.Codigo == "PESO" ? "$" : "U$S"}
                                                                </option>
                                                            )) : [];

        return (
            <div>
                <div className={"AsientosContables__modalDetalleAsiento__contenedorRegistroGrilla"}>
                    <div className={"seccionRenglonesModelo__renglonModelo__contenedorRegistros AsientosContables__modalDetalleAsiento__registroGrillaRenglon AsientosContables--noPadding" + estiloCursiva}>
                        {registro && registro.ModeloContableCabeceraId == null ?
                            <div>
                                <input type="text" 
                                    className="AsientosContables__modalDetalleAsiento__registroGrillaInput" 
                                    value={registro.DescripcionRenglon}
                                    onChange={(event) => this.props.actualizarDescripcionRenglon(registro.renglonId, event.target.value)}
                                />
                            </div>
                        :
                            <span {...registro && registro.DescripcionRenglon && registro.DescripcionRenglon.length > 30 && { "data-toggle": "tooltip", title: registro.DescripcionRenglon }}>
                            {registro ? asientoContableDescripcion : ""}</span>
                        }
                    </div>

                    <div className={"seccionRenglonesModelo__renglonModelo__contenedorRegistros AsientosContables__modalDetalleAsiento__registroGrillaCuentaContable AsientosContables__modalDetalleAsiento__registroGrillaCuentaContable--widthDetalleRenglon AsientosContables--noPadding" + estiloInputRenglonCuentaContable + estiloCuentaContableHaber + estiloCursiva}>
                        {registro && registro.TipoOperacion == 2 && registro.ModeloContableCabeceraId == null ? "a) " : ""}
                        {registro && registro.ModeloContableCabeceraId == null ?   
                                <div className="AsientosContables_ModalDetalleAsiento_ContenedorBuscadorCuentasContables">
                                    <BuscadorCuentasContables
                                        buscarCuentasContables={this.buscarCuentasContables}
                                        cuentasContables={cuentasFiltradasPorMoneda}
                                        cambiarValorInput={this.handleInputBuscadorChange}
                                        cambiarInputActivo={cambiarInputActivo}
                                        estaHabilitado={true}
                                        valorInput={this.state.inputBuscadorCuentaContable}
                                        guardarValorInput={this.handleGuardarValorInput}
                                        inputActivo={activaInputBuscador}
                                        nroRenglon={registro.renglonId}
                                        nombreInput={"inputCuentaContable"}
                                        seccionInput={"propsModalNuevoAsiento"}
                                        esHaber={!!totalHaberValor}
                                        onValorReferenciaChange={onValorReferenciaChange}
                                        inputClassValorSeleccionado={hayCuentaSeleccionada ? " AsientosContables__buscadorCuentasContables--valorSeleccionado" : ""}
                                        contenedorInputBuscador={"AsientosContables_ModalDetalleAsiento_BuscadorCuentasContables--width"}
                                    />
                                </div>
                        :
                            registro ? <span {...registro && registro.CuentaContableDescripcion && registro.CuentaContableDescripcion.length > 32 && { "data-toggle": "tooltip", title: registro.CuentaContableDescripcion }}>
                                            {registro && registro.TipoOperacion === 2 ? "a) " : ""}
                                            {registro && registro.CuentaContableCodigo + ' - ' + cuentaContableDescripcion}
                                        </span> : ""
                        }
                    </div>

                    
                    <div className={"seccionRenglonesModelo__renglonModelo__contenedorRegistros AsientosContables__modalDetalleAsiento__registroGrillaDebe "}>
                        {registro && (registro.TipoOperacion === 1 || registro.RenglonAgregadoManualmente) ? (
                            <div style={{ display: this.state.debeActivo ? 'block' : 'none' }}>
                                {simboloMoneda}
                                {registro && registro.RenglonAgregadoManualmente && this.state.debeActivo ? (
                                    <select
                                        name="comboMoneda"
                                        className="seccionDatosGenerales__inputSelect seccionDatosGenerales__sucursalSelect AsientosContables--noMargin AsientosContables--combo-seleccion-moneda-grilla"
                                        value={registro && registro.ModeloMonedaSalidaId} 
                                        onChange={this.handleMonedaChange}>
                                             {monedasCombo}
                                    </select>
                                ) : null}
                                <input
                                    type="text"
                                    className="seccionDatosGenerales__inputSelect AsientosContables__filtrosAdicionalesIdAsientoMoneda AsientosContables__inputImporteGrilla"
                                    name="inputImporteDebe"
                                    id="inputImporteDebe"
                                    value={registro.TipoOperacion === 1 && registro?.ImporteAsiento? registro.ImporteAsiento : ''}
                                    onChange={this.handleImporteChange}
                                    pattern="[0-9]*"
                                />
                            </div>
                        ) : (
                            totalDebe
                        )}
                    </div>

                    <div className={"seccionRenglonesModelo__renglonModelo__contenedorRegistros AsientosContables__modalDetalleAsiento__registroGrillaHaber "}>
                        {registro && (registro.TipoOperacion === 2 || registro.RenglonAgregadoManualmente) ? (
                            <div style={{ display: this.state.haberActivo ? 'block' : 'none' }}>
                                {simboloMoneda}
                                {registro && registro.RenglonAgregadoManualmente && this.state.haberActivo ? (
                                    <select
                                        name="comboMoneda"
                                        className="seccionDatosGenerales__inputSelect seccionDatosGenerales__sucursalSelect AsientosContables--noMargin AsientosContables--combo-seleccion-moneda-grilla"
                                        value={registro && registro.ModeloMonedaSalidaId} 
                                        onChange={this.handleMonedaChange}>
                                             {monedasCombo}
                                    </select>
                                ) : null}
                                <input
                                    type="text"
                                    className="seccionDatosGenerales__inputSelect AsientosContables__filtrosAdicionalesIdAsientoMoneda AsientosContables__inputImporteGrilla"
                                    name="inputImporteHaber"
                                    id="inputImporteHaber"
                                    value={registro.TipoOperacion === 2 && registro?.ImporteAsiento ? registro.ImporteAsiento : ''}
                                    onChange={this.handleImporteChange}
                                    pattern="[0-9]*"
                                />
                            </div>
                        ) : (
                            totalHaber
                        )}
                    </div>


                    
                    <div className="seccionRenglonesModelo__renglonModelo__contenedorRegistros AsientosContables__modalDetalleAsiento__botonDesplegableGrilla">
                        {registro ? 
                            <div className={estaDesplegado ? "seccionRenglonesModelo__renglonModelo__trianguloUp seccionRenglonesModelo__renglonModelo__trianguloUp--activo" : "seccionRenglonesModelo__renglonModelo__trianguloDown"} onClick={() => desplegarDatosDetalleRenglonNuevoAsiento(registro.renglonId, "propsModalNuevoAsiento")}></div>
                        :
                            null
                        }
                    </div>
                </div>
                <div className={"AsientosContables__modalNuevoAsiento__datosAdicionales AsientosContables--overflowHidden slider-tarjetas" + (estaDesplegado ? "" : " AsientosContables__modalNuevoAsiento__datosAdicionales--sinDesplegar closed")}>
                    {registro ?
                        <div className="AsientosContables__modalNuevoAsiento__datosAdicionales--margin">
                            <div className="AsientosContables__modalNuevoAsiento__datosAdicionalesContenedorCentroCostos AsientosContables--floatLeft">
                                <label>Centro de costos:</label>
                                {registro?.RenglonAgregadoManualmente ? (
                                    <select 
                                        className="seccionDatosGenerales__inputSelect AsientosContables__modalNuevoAsiento__datosAdicionalesInputSelect"
                                        id="comboCentroCostos"
                                        name="comboCentroCostos"
                                        value={valorComboCentroCosto}
                                        onChange={this.handleCentroCostoChange}
                                    >
                                        <option key="0" value="0">Ninguno</option>
                                        {centrosDeCosto}
                                    </select>
                                ) : (
                                    <span>{registro.CentroCostoDescripcion || "Ninguno"}</span>

                                )}
                            </div>

                            <div className="AsientosContables__modalNuevoAsiento__datosAdicionalesContenedorTipoReferencia AsientosContables--floatLeft">
                                <label>Tipo de referencia: </label>
                                    {registro?.RenglonAgregadoManualmente ? (
                                        <select 
                                            className="seccionDatosGenerales__inputSelect AsientosContables__modalNuevoAsiento__datosAdicionalesInputSelect"
                                            id="comboTipoReferencia"
                                            name="comboTipoReferencia"
                                            onChange={this.handleTipoReferenciaChange}
                                            value={valorComboValorReferencia}
                                        >
                                      <option key="0" value="0">Ninguna</option>
                                      <option key="2" value="2">{descripcionCuentaContable}</option>
                                      <option key="3" value="3">Otra</option>
                                        </select>
                                    ) : (
                                        <span>{tipoReferenciaTexto}</span>
                                    )}
                                {valorComboValorReferencia === "3" && (
                                    <div className="AsientosContables--floatLeft AsientosContables__modalDetalleAsiento__registrosAdicionalesColumnaDerecha AsientosContables__modalNuevoAsiento_widthContenedorInputValorReferencia">
                                        <input type="text" className="inputDatosAdicionalesRenglonManual AsientosContables__modalNuevoAsiento_inputValorReferencia" placeholder="Valor de referencia"  value={valorInputReferencia} onChange={this.handleInputReferenciaChange}/>
                                    </div>
                                   )}
                            </div>

                            {registro?.RenglonAgregadoManualmente && (
                                <div className="seccionRenglonesModelo__renglonModelo__accionEliminar AsientosContables__modalNuevoAsiento__datosAdicionalesContenedorBotonEliminar" onClick={() => borrarRenglon(registro.renglonId)}></div>
                            )}
                        </div>
                    : null}
                </div>
            </div>
        );
    }
}

export default RegistroRenglonAsiento;